export const BASE_URL = 'https://kashiassociates.com/api/';